import CloseIcon from '@mui/icons-material/Close';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import { useState } from 'react';
import { useEngageActionPlan } from '../../../sic-lib/api/hooks/useEngageActionPlan';
import { Contact } from '../../../sic-lib/types/Contact';
import Loader from '../../Shared/Loader';
import AutomationDialogItem from './AutomationDialogItem';
import AutomationDialogTimeline from './AutomationDialogTimeline';

interface Props {
    onCloseHandler: () => void;
    contact: Contact;
    isDialogOpen: boolean;
    hasAiFeature: boolean;
}

export default function AutomationDialog({
    onCloseHandler,
    contact,
    isDialogOpen,
    hasAiFeature,
}: Props) {
    const [selectedPlanId, setSelectedPlanId] = useState<number | undefined>(undefined);

    const { data: engageActionPlan, isLoading: isLoadingEngageActionPlan } = useEngageActionPlan(
        contact.contactId,
    );

    const handleClose = () => {
        onCloseHandler();
    };

    return (
        <Dialog open={isDialogOpen} maxWidth="md" onClose={handleClose} fullWidth>
            <DialogTitle>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <ScheduleSendIcon fontSize="medium" />
                    <Typography variant="h5">Action Plans</Typography>

                    <IconButton
                        onClick={handleClose}
                        sx={theme => {
                            return { ml: 'auto', color: theme.palette.appHeader.contrastText };
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Grid container columnSpacing={2}>
                    <Grid item md={4} xs={12}>
                        <Stack direction="column" display="flex" gap={2}>
                            <Typography variant="h6">Action Plans</Typography>
                            {isLoadingEngageActionPlan && <Loader />}
                            {engageActionPlan?.map((plan, index) => (
                                <AutomationDialogItem
                                    key={plan.id}
                                    engageActionPlan={plan}
                                    selectedId={selectedPlanId}
                                    onSelectPlan={setSelectedPlanId}
                                />
                            ))}
                        </Stack>
                    </Grid>
                    <Grid item md={8} xs={12}>
                        <Stack direction="column" display="flex" gap={2}>
                            <Typography variant="h6">Action Plan Timeline</Typography>
                            <AutomationDialogTimeline
                                contactId={contact.contactId}
                                selectedId={selectedPlanId}
                            />
                        </Stack>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}
